// extracted by mini-css-extract-plugin
module.exports = {"story_newtaste":"StoryNewTaste_story_newtaste___TC_q","story_mobile_newtaste":"StoryNewTaste_story_mobile_newtaste__HhP4L"};